import axios from "./axios"

// const API_BASE_URL = "http://localhost:3003"
const API_BASE_URL = "api"
const API_URL = API_BASE_URL + "/auth"

export const login = (email, password) => {
	return axios
		.post(API_URL + "/login", {
			email,
			password,
		})
		.then((res) => {
			// sessionStorage.setItem(
			// 	"access_token",
			// 	JSON.stringify({
			// 		...res.data
			// 	})
			// )
			sessionStorage.setItem(
				"accessToken",
				JSON.stringify(res.data.access_token)
			)
			return res.data
		})
}

export const isAuthenticated = (): boolean => {
	if (sessionStorage.getItem("accessToken") != null) {
		return true
	} else {
		return false
	}
}

export const getCurrentUser = () => {
	return JSON.parse(sessionStorage.getItem("user") || "")
}

export const resetPassword = (email) => {
	return axios
		.post(API_URL + "password/reset", {
			email,
			appType: "internal", // Uvek se vracaju podaci za internal.
		})
		.then((res) => res.data)
}

export const activate = (password, token) => {
	return axios
		.post(API_URL + "activate/" + token, {
			password,
		})
		.then((res) => res.data)
}
